import * as React from "react";
import { LinkToNode } from "components/common";
import useProductName from "brand-customization/useProductName";
const NodeCell = ({ input }) => {
  const productName = useProductName();
  if (input.global && !input.node) return `All ${productName} Nodes`;
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(LinkToNode, { nodeId: input.node }));
};
export default NodeCell;
